import React, { useEffect, useState } from 'react';
import styles from './CreateEvaluationQuestion.module.scss';
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs';
import Button from '../../../components/button/Button';
import TextAreaField from '../../../components/textAreaField/TextAreaField';
import MultiSelectDropdown from '../../../components/multiSelectDropdown/MultiSelectDropdown';
import LoadingOverlay from '../../../components/loadingOverlay/LoadingOverlay';
import axiosClient from '../../../api/axiosClient';
import { useToasts } from '../../../contexts/ToastContext';
import { useNavigate, useParams } from 'react-router-dom';

const CreateEvaluationQuestion = () => {
  const { questionId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [allTags, setAllTags] = useState([]);
  const [formData, setFormData] = useState({
    question: '',
    tags: [],
  });

  useEffect(() => {
    if (!questionId) return;
    const fetchQuestion = async () => {
      setIsLoading(true);
      try {
        const response = await axiosClient.get(`/evaluation-questions/${questionId}`);
        const data = response.data;
        setFormData({
          question: data.question || '',
          tags: data.tags || [],
        });
        setAllTags(data.allTags || []);
      } catch (error) {
        showToast(error.message, 'error');
      } finally {
        setIsLoading(false);
      }
    };
    fetchQuestion();
  }, [questionId, showToast]);

  const handleSave = async () => {
    if (!formData.question) {
      showToast('Question is required', 'error');
      return;
    }
    setIsSaving(true);
    try {
      await axiosClient.patch(`/evaluation-questions/${questionId}`, {
        question: formData.question,
        tags: formData.tags,
      });
      showToast('Question updated successfully', 'success');
      navigate('/evaluation-questions');
    } catch (error) {
      showToast(error.message, 'error');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <div className={styles.breadcrumbs}>
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Evaluation Questions', path: '/evaluation-questions' },
            { label: 'Edit Question' },
          ]}
        />
      </div>
      <div className={styles.container}>
        {(isLoading || isSaving) && <LoadingOverlay />}
        <div className={styles.form}>
          <div className={styles.row}>
            <div className={styles.column}>
              <TextAreaField
                label="Question"
                value={formData.question}
                onChange={(value) => setFormData((prev) => ({ ...prev, question: value }))}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.column}>
              <MultiSelectDropdown
                label="Tags"
                options={allTags.map((t) => ({ value: t, label: t }))}
                selected={formData.tags}
                onChange={(values) => setFormData((prev) => ({ ...prev, tags: values }))}
              />
            </div>
          </div>
          <div className={styles.actions}>
            <Button
              label="Cancel"
              variant="white"
              size="medium"
              onClick={() => navigate('/evaluation-questions')}
            />
            <Button
              label="Save"
              variant="primary"
              size="medium"
              isLoading={isSaving}
              onClick={handleSave}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateEvaluationQuestion;
